<template lang="pug">
  .case-sample
    .case-sample-container
      .title {{ $t('参考案例') }}
      .case-sample-items
        .case-sample-item(
          v-for="(item, i) in data"
          @click="onClickCase(item.url)"
        )
          img(
            :src="item.img"
          )
          .item-title {{ $t(item.title) }}
          .item-desc {{ $t(item.desc) }}
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    onClickCase (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="stylus">

@media (max-width: 767px)
  .case-sample-container
    padding 0 24px
  .case-sample-items
    flex-direction column
    .case-sample-item
      img
        width 100%

@media (max-width: 1370px) and (min-width: 768px)
  .case-sample-container
    padding 0 72px
  .case-sample-items
    width 100%
    flex-wrap wrap
    .case-sample-item
      width 48%
      img
        width 100%

.case-sample
  background #f6f7fb
  .case-sample-container
    .title
      padding-top 42px
      font-size 22px
      color $black-title
      font-weight 600
      margin-bottom 36px
  .case-sample-items
    display flex
    align-items center
    justify-content space-between
  .case-sample-item
    margin-bottom 42px
    .item-title
      color #478bca
      font-size 22px
      font-weight 600
      margin 18px 0 13px
    .item-desc
      width 100%
      color #595b74
      line-height 1.56
      font-size 16px
</style>
